// extracted by mini-css-extract-plugin
export default {"message":"ErrorBox_message__tFziu","close":"ErrorBox_close__hB6Sr","hide":"ErrorBox_hide__-kx6D"};